import React from 'react';

export const getProperties = (props) => {
  const asArray = Object.entries(props);
  const filtered = asArray.filter(([key, value]) => typeof value !== 'function');
  return Object.fromEntries(filtered);
};

export const connectorWrapper = (connectorHook, Component) => {
  const Wrapper = props => {
    const restProps = getProperties(props);

    const data = connectorHook(restProps);
    return <Component {...props} {...data} />;
  };
  return Wrapper;
};
